import {AbstractControl, ValidationErrors} from '@angular/forms';
import {UserRolesEnum} from '../user-roles.enum';
import {Utils} from '@astek/utils';

export function userRoleEnumValidator(control: AbstractControl): ValidationErrors | null {
  if (!Utils.enumValueExists(control.value as string, UserRolesEnum)) {
    return {unAuthorizedValues: control.value as string};
  }
  return null;
}
